import React, { createContext, useContext, useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../services/firebase-init';
import customerService from '../services/customer-service';

const CustomerContext = createContext();
export function useCustomerContext() { return useContext(CustomerContext); }

export function CustomerProvider({ children }) {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => {
      if (user) {
        customerService.startListener((updatedCustomers) => {
          setCustomers(updatedCustomers);
          setLoading(false);
        });
      } else {
        customerService.stopListener();
        setCustomers([]);
        setLoading(false);
      }
    });
    return () => { unsub(); customerService.stopListener(); };
  }, []);

  const value = {
    customers, loading, customerService,
    getCustomer: (id) => customerService.getCustomer(id),
    addCustomer: (data) => customerService.addCustomer(data),
    updateCustomer: (id, updates) => customerService.updateCustomer(id, updates),
    deleteCustomer: (id) => customerService.deleteCustomer(id),
    searchCustomers: (term) => customerService.searchCustomers(term),
    findDuplicates: (data) => customerService.findDuplicates(data),
  };
  return <CustomerContext.Provider value={value}>{children}</CustomerContext.Provider>;
}
